// eslint-disable-next-line import/no-cycle
import { getEnum } from '@/api/global'

// 枚举值mutation映射
const ENUM_MAP = {
  repaymentMethod: 'SET_REPAYMENT_METHODS',
  leaseModel: 'SET_RENT_METHODS',
  financialInstitution: 'SET_FINANCE_INSTITUTION',
  carResourceLeaseType: 'SET_PLAN_TYPE',
  releaseState: 'SET_PUBLISH_STATE',
}

// 格式转换
const transform = (arr) => {
  return arr.map((item) => {
    return {
      label: item.name,
      value: item.code,
    }
  })
}

// 车辆资源包公用枚举
const carResource = {
  state: {
    // 还款方式
    repaymentMethod: [],
    // 租赁模式
    leaseModel: [],
    // 金融机构
    financialInstitution: [],
    // 方案类型
    carResourceLeaseType: [],
    // 发布状态
    releaseState: [],
  },
  mutations: {
    SET_REPAYMENT_METHODS(state, methods) {
      state.repaymentMethod = methods
    },
    SET_RENT_METHODS(state, methods) {
      state.leaseModel = methods
    },
    SET_FINANCE_INSTITUTION(state, institutions) {
      state.financialInstitution = institutions
    },
    SET_PLAN_TYPE(state, types) {
      state.carResourceLeaseType = types
    },
    SET_PUBLISH_STATE(state, states) {
      state.releaseState = states
    },
  },
  actions: {
    getCarResourceEnum({ commit }, type) {
      return new Promise((resolve) => {
        getEnum({ type }).then((res) => {
          if (res.code === 1) {
            const data = transform(res.data)
            commit(ENUM_MAP[type], data)
            resolve(data)
          }
        })
      })
    },
  },
}

export default carResource
